import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['container'];

  connect() {
    this.bindEvents();
  }

  disconnect() {
    window.removeEventListener('payment:updated', this.handlePaymentUpdate);
  }

  bindEvents() {
    this.handlePaymentUpdate = this.showNotification.bind(this);
    window.addEventListener('payment:updated', this.handlePaymentUpdate);
  }

  showNotification(event) {
    const { status, message } = event.detail;

    const alertClass = status === 'complete' ? 'alert-success' : status === 'failed' ? 'alert-danger' : 'alert-info';

    const notification = `
      <div class="alert ${alertClass} alert-dismissible fade show" role="alert">
        ${message}
        <button type="button" class="close" data-dismiss="alert" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
    `;

    this.containerTarget.innerHTML = notification;

    setTimeout(() => {
      const alert = this.containerTarget.querySelector('.alert');
      if (alert) {
        if (alert.classList.contains('show')) {
          alert.classList.remove('show');
          setTimeout(() => {
            alert.remove();
          }, 150);
        } else {
          alert.remove();
        }
      }
    }, 5000);
  }
}
